import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
if (!BACKEND_URL) {
  // Fail loudly at boot rather than emit `undefined/api` requests silently.
  // eslint-disable-next-line no-console
  console.error(
    "[Aplikasi Kontrakan] REACT_APP_BACKEND_URL kosong! Set di frontend/.env lalu rebuild:\n" +
      "  REACT_APP_BACKEND_URL=https://domain-anda.com"
  );
}
export const API = `${BACKEND_URL || ""}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
